import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {tap, concatMap, map} from 'rxjs/operators';
import {MergeQuestiondataService} from '../../services/merge-questiondata.service';
import {IIdentifier, ResponseLoadBankamountData} from 'build/project/openapi-cast/project/project-openapi-cast.model';
import {IAllFieldItems} from '../field-item-row/row.model';

@Injectable({
   providedIn: 'root'
})
export class BankamountService {
   
   private question_: IAllFieldItems = {} as IAllFieldItems;
   private textAmount_?: string;
   private amount_: number | null = 0;
   private showComponent_: boolean = true;

   get question (): IAllFieldItems {
      return this.question_;
   }

   get textAmount (): string {
      return this.textAmount_ || "";
   }

   get amount (): number | null {
      return this.amount_;
   }

   get showComponent (): boolean {
      return this.showComponent_;
   }

   constructor (private sMergeQuestionData: MergeQuestiondataService) {
   }

   public loadData (iid: IIdentifier): Observable<boolean> {
      return this.sMergeQuestionData.loadBankamountData(iid).pipe(
         concatMap((bankamountData: ResponseLoadBankamountData) => bankamountData.textAmount == "-1" ? of(this.showComponent_ = false) : of(bankamountData)),
         concatMap((bankamountData: ResponseLoadBankamountData | boolean) => typeof bankamountData == "boolean" ? of(bankamountData) : bankamountData.textcodeAmount == "-1" ? of({...bankamountData, textcodeAmount: ""}) : of(bankamountData)),
         tap((bankamountData: ResponseLoadBankamountData | boolean) => typeof bankamountData == "boolean" ? of(bankamountData) : this.setAmount(bankamountData)),
         tap((bankamountData: ResponseLoadBankamountData | boolean) => typeof bankamountData == "boolean" ? of(bankamountData) : this.setQuestion(bankamountData)),
         map((bankamountData: ResponseLoadBankamountData | boolean) => typeof bankamountData == "boolean" ? false : true)
      );
   }

   private setQuestion (bankamountData: ResponseLoadBankamountData): void {
      this.question_.question_id = "bankAmountToggle";
      this.question_.disabled = bankamountData.textAmount == "-1";
   }

   private setAmount (bankamountData: ResponseLoadBankamountData): void {
      this.amount_ =  !(bankamountData.amount) || bankamountData.amount == -1 ? 0 : bankamountData.amount;
      this.textAmount_ = bankamountData.textAmount && bankamountData.textAmount !== "-1" ? bankamountData.textAmount : "";
   }
}
